/**
 * @file 导出入口
 */
import Invoke from './invoke/index';
import Utils from './utils/index';

// export default Invoke;
const RmbGrowthBox = {
    // 基础库版本
    version: '1.0.0',
    Invoke,
    Utils
};

export {
    Invoke,
    Utils
};
window.RmbGrowthBox = RmbGrowthBox;
export default RmbGrowthBox;
